<template>
<v-layout row>
        <v-flex xs12>
            <v-card>
                <v-card-title primary-title class="grey lighten-4">
                    <v-tooltip top>
                         <v-btn
                            slot="activator"
                            dark
                            @click.stop="helpdialog = true"
                            icon class="mx-0">
                        <v-icon color="red">help</v-icon>
                        </v-btn>
                        <span>Roles/App</span>
                    </v-tooltip>
                    <h3 class="headline mb-0">Administración de Roles</h3>

                    <v-spacer></v-spacer>
                        <v-text-field
                            @change="onChange"
                            slot="input"
                            v-model="search"
                            append-icon="search"
                            label="Buscar"
                            single-line
                            hide-details
                        ></v-text-field>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" dark class="mb-2" @click="addRole">Agregar</v-btn>
                </v-card-title>
                <div>

                  <v-data-table
                    :headers="headers"
                    :items="roles"
                    :pagination.sync="pagination"
                    :total-items="total"
                    :rows-per-page-items="rowsPerPageItems"
                    :loading="loading"
                    row
                    wrap
                    class="elevation-1"
                  >
                    <template v-slot:items="props">
                      <td>{{ props.item.name }}</td>
                      <td class="text-xs-left">{{ props.item.description }}</td>
                      <td class="justify-center layout px-0">


                        <v-tooltip left>
                            <v-btn
                            slot="activator"
                            icon class="mx-0"
                            @click="editItem(props.item)">
                              <v-icon
                              color="blue"
                              class="mr-2"

                            >
                          edit
                            </v-icon>
                                </v-btn>
                                <span>Eitar Roles</span>
                        </v-tooltip>


                        <v-tooltip top>
                            <v-btn
                            slot="activator"
                            icon class="mx-0"
                            @click="deleteItem(props.item)">
                        <v-icon
                          color="red"
                        >
                          delete
                        </v-icon>
                        </v-btn>
                            <span>Permisos a Roles</span>
                        </v-tooltip>


                          <v-tooltip right>
                            <v-btn
                            slot="activator"
                            icon class="mx-0"
                            @click="changePermissionRole(props)">
                              <v-icon
                              dark
                              color="green">group_add</v-icon>
                            </v-btn>
                            <span>Permisos a Roles</span>
                        </v-tooltip>

                      </td>

                    </template>
                    <!-- <template v-slot:no-data>
                      <v-btn color="primary" @click="initialize">Limpiar</v-btn>
                    </template> -->

                  </v-data-table>
                </div>

            </v-card>
        </v-flex>


  <!-- Inicio de dialogo -->
    <v-dialog
          v-model="helpdialog"
          max-width="600"
        >
          <v-card>
            <v-card-title class="headline">Roles</v-card-title>

            <v-card-text>
              Mantenimiento de la tabla de Roles del sistema para gestionar el acceso a las funcionalidades del mismo.
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>

              <v-btn
                color="green darken-1"
                flat="flat"
                @click="helpdialog = false"
              >
                Salir
              </v-btn>

            </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Fin de dialogo -->

    <!-- dialog para form role permission -->
    <v-dialog v-model="dialogPermissionRole" width="600" persistent>
      <formRolePermission :loading="loading" v-if="dialogPermissionRole" :id="id" v-on:closeDialogPermissionRole="closeDialogPermissionRole()" v-on:loadingResponse="loading = $event" />
    </v-dialog>
    <!-- fin dialog form role permission -->

    <!-- dialog para form roles -->
    <v-dialog v-model="dialog" width="600">
      <FormRole :tipo="tipo" :datos="getRoles" v-on:closeDialogRole="closeDialogRole($event)" />
    </v-dialog>
    <!-- fin dialog form roles -->

    </v-layout>
</template>

<script>
import axios from 'axios'
import FormRole from '~/components/form/formRole.vue'
import formRolePermission from '~/components/form/formRolePermission.vue'

  export default {
    name: "admin-roles-view",

    components: {
      FormRole,
      formRolePermission
    },

    data: () => ({
      dialog: false,
      nota: {nombre: '', descripcion: ''},
      helpdialog: false,
      loading: false,
      total: 0,
      tipo: '',
      search: '',
      pagination: {},
      dialogPermissionRole: false,
      headers: [
        { text: 'Nombre', align: 'left', sortable: false, value: 'name' },
        { text: 'Descripción', align: 'left', sortable: false, value: 'description' },
        { text: 'Acciones', align: 'center', value: '', sortable: false }
      ],
      rowsPerPageItems: [10, 20, 50, 100],
      roles: [],
      editedIndex: -1,
      editedItem: {
        name: '',
        description: ''
      },
      defaultItem: {
        name: '',
        description: ''
      }
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'Registrar nuevo Rol' : 'Editar Rol'
      },
      getRoles () {
          return this.editedItem
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      pagination() {
        this.getRoleByPagination();
      }
    },

    methods: {

      editItem (item) {
        this.tipo = "editar"
        this.editedIndex = this.roles.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      addRole () {
        this.tipo = "crear"
        this.dialog = true
      },

    changePermissionRole(props) {
      this.id = props.item.id
      this.dialogPermissionRole = true
    },

      deleteItem (item) {
        const index = this.roles.indexOf(item)
        let confirmDelete =  confirm(`se eliminará el ROLE:  ${item.name}, está seguro?`) && this.roles.splice(index, 1)
        if(confirmDelete){
        axios.delete(`/api/roles/admin/${item.id}`)
          .then(()=>{
            this.roles.splice(index, 1);
          })
          .catch(error => {
              console.log(error.response);
            });
      }
      },

      close () {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      save () {
        if (this.editedIndex > -1) { // update
          let formData = new FormData();
          for (var key in this.editedItem) {
            formData.append(key, this.editedItem[key]);
          }
          //console.log(this.editedItem,'aa')
          formData.set('_method', 'patch')
          axios.post(`/api/roles/admin/update_role`, formData)
          .then((resp) => {
            this.search = resp.data.name
            this.getRoleByPagination();
          })
          .catch(error => {
              console.log(error.response);
          });

        } else { // create
          this.submitFormRoles()
        }
        this.close()
      },

      async submitFormRoles () {
        axios.post(`/api/roles/admin/create_role`, this.editedItem)
          .then((resp) => {
            this.search = resp.data.name
            this.getRoleByPagination();
            //this.roles.push(resp.data)
          })
          .catch(error => {
              console.log(error.response);
          });
      },

      async getRoleByPagination() {
            this.loading = true;
            if (this.search) {
                await axios.get(`/api/administration/roles/roles-filter?query=${this.search}&page=${this.pagination.page}&per_page=${this.pagination.rowsPerPage}`)
                    .then(res => {
                        //console.log(res, 'data')
                        this.roles = res.data.data;
                        this.total = res.data.total;
                    })
                    .finally(() => this.loading = false);
            }
            if (this.pagination.sortBy && !this.search) {
                const direction = this.pagination.descending ? 'desc' : 'asc';
                await axios.get(`/api/administration/roles/roles-order?direction=${direction}&sortBy=${this.pagination.sortBy}&page=${this.pagination.page}&per_page=${this.pagination.rowsPerPage}`)
                    .then(res => {
                        //console.log(res, 'data')
                        this.loading = false;
                        this.roles = res.data.data;
                        this.total = res.data.total;
                    })
                    .finally(() => this.loading = false);
            }
            if(!this.search && !this.pagination.sortBy) {
                await axios.get(`/api/administration/roles?page=${this.pagination.page}&per_page=${this.pagination.rowsPerPage}`)
                    .then(res => {
                        //console.log(res, 'data')
                        this.roles = res.data.data;
                        this.total = res.data.total;
                    })
                    .finally(() => this.loading = false);
            }
        },

        closeDialogPermissionRole () {
          this.dialogPermissionRole = false
          setTimeout(function(){
            this.id = null
          }, 3000)
        },

        onChange () {
            this.getRoleByPagination();
        },

        closeDialogRole (response) {
          if (response != null) {
            var item = this.roles.find(roles => roles.id === response.id)
            if (this.tipo == 'crear') {
              this.roles.push(response)
            }else {
              Object.assign(item, response)
            }
            this.search = response.name
            this.getRoleByPagination();
          }
          this.dialog = false
          setTimeout(function(){
            this.editItem = {}
            this.tipo = ''
          }, 3000)
        }

    }
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/admin/adminRoles.vue